// 扩展后的计费计算器
class CreditCalculator {
  static INPUT_DURATION_SUFFIX = "_input_duration";

  static calculateCost(modelConfig, formData) {
    const { type } = modelConfig;

    switch (type) {
      case "factor_based": // 因子计算
        return this.calculateFactorBased(modelConfig, formData);
      case "per_second": // 每秒计算
        return this.calculatePerSecond(modelConfig, formData);
      case "fixed_per_image": // 固定每张图片计算
        return this.calculateFixedPerImage(modelConfig, formData);
      case "fixed_per_request": // 固定每请求计算
        return this.calculateFixedPerRequest(modelConfig, formData);
      default: // 不支持的计算类型
        throw new Error(`Unsupported cost type: ${type}`);
    }
  }

  /**
     * 因子计算 (动态重构版)
     * @param {Object} config - 包含 base_cost 和 factors 的配置对象
     * @param {Object} formData - 用户提交的表单数据
     */
  static calculateFactorBased(config, formData) {
    const { base_cost = 0, factors = {} } = config;

    // 使用 reduce 进行累乘计算
    const totalFactor = Object.keys(factors).reduce((acc, key) => {
      const userValue = formData[key]; // 获取用户选择的值，例如 "1080p"

      // 逻辑链条：
      // 1. 检查 formData 是否提供了该因子的值
      // 2. 检查 factors 配置中是否存在该值的系数
      // 3. 如果都不匹配，回退系数为 1 (不影响乘积)
      const factorMultiplier = factors[key]?.[userValue] ?? 1;
      return acc * factorMultiplier;
    }, 1);

    const cost = base_cost * totalFactor;

    // 返回保留三位小数的数值
    return Number(cost.toFixed(3));
  }

  // 每秒计算
  static calculatePerSecond(config, formData) {
    const { per_second_cost, multipliers = {}, duration_key } = config;
    const duration = this.resolveDurationSeconds(formData, duration_key);

    // 使用 reduce 进行累乘计算
    const totalMultiplier = Object.keys(multipliers).reduce((acc, key) => {
      const userValue = formData[key]; // 获取用户选择的值，例如 "1080p"
      let multiplier = 1;
      if (typeof userValue === 'boolean') {
        multiplier = userValue ? multipliers[key] : 1;
      } else {
        multiplier = multipliers[key]?.[userValue] ?? 1;
      }
      return acc * multiplier;
    }, 1);

    const cost = per_second_cost * duration * totalMultiplier;
    return Number(cost.toFixed(3));
  }

  static resolveDurationSeconds(formData, durationKey) {
    debugger;
    const explicitDuration = Number(formData?.[durationKey]);
    if (Number.isFinite(explicitDuration) && explicitDuration > 0) {
      return explicitDuration;
    }

    const uploadDuration = this.resolveUploadDuration(formData, durationKey);
    if (Number.isFinite(uploadDuration) && uploadDuration > 0) {
      return uploadDuration;
    }

    return 1;
  }

  static resolveUploadDuration(formData, durationKey) {
    if (
      typeof durationKey !== "string" ||
      !durationKey.endsWith(this.INPUT_DURATION_SUFFIX)
    ) {
      return null;
    }

    const sourceKey = durationKey.slice(0, -this.INPUT_DURATION_SUFFIX.length);
    if (!sourceKey) return null;

    const byFieldKey = Number(
      formData?.__uploadDurationsByFieldKey?.[sourceKey]
    );
    if (Number.isFinite(byFieldKey) && byFieldKey > 0) {
      return byFieldKey;
    }

    const byParamsKey = Number(
      formData?.__uploadDurationsByParamsKey?.[sourceKey]
    );
    if (Number.isFinite(byParamsKey) && byParamsKey > 0) {
      return byParamsKey;
    }

    return null;
  }

  // 固定每张图片计算
  static calculateFixedPerImage(config, formData) {
    const { cost_per_image, image_num_key } = config;
    // const imageCount = formData?.["image_output_num"] || 1; // 支持生成多张图片 固定 image_output_num 字段

    // const cost = cost_per_image;
    // console.log(`计算公式: ${cost_per_image} * ${imageCount} = ${cost}`);
    return Number(cost_per_image.toFixed(3));
  }

  // 固定每请求计算
  static calculateFixedPerRequest(config, formData) {
    const { fixed_cost } = config;
    return Number(fixed_cost.toFixed(4));
  }

  static toCredits(cost, creditRatio = 150) {
    // 转换为积分 向上取整 去掉小数
    return this.ceilToZeroDecimals(cost * creditRatio);
  }

  static ceilToZeroDecimals(num) {
    // 1. 先四舍五入到足够的精度，消除浮点数误差。
    // 2. 然后再乘以100，进行向上取整。
    const roundedNum = Math.round(num * 10000) / 10000; // 示例：先四舍五入到四位小数
    return Math.ceil(roundedNum);
  }
}


// 运行测试
// runTests();

export default CreditCalculator;
